				   // For full API documentation, including code examples, visit https://wix.to/94BuAAs

import {getLocations} from 'backend/locations';



$w.onReady(function () {
	//TODO: write your page related code here...
 sendLocations();
	$w("#html1").onMessage( (event) => {
		if(event.data === 'hello') {
			sendLocations();
		}
		else {
			$w('#txtLocationClicked').text = "Clicked on the Wix Office location: " + event.data;
		}
	} );
});

function sendLocations() {
	getLocations().then((locations) => {
		let markers = [];
		for (let i = 0; i < locations.length; i++) {
			let loc = locations[i];
			markers.push({title: loc.shortTextField, position: {lat: loc.longitude, lng: loc.numberField2}, href: loc['link-scenarios-_id']});	
		}
		$w('#html1').postMessage({markers});
	});
}
 